module.exports = __webpack_public_path__ + "docs/liquidity-pool-2066c5.md";